/**
 * Helper functions for organism (algae) management
 */

/**
 * Add a new organism group
 */
export const addNewGroupHelper = (
  newGroupName,
  organismGroups,
  setOrganismGroups,
  setManualGroup,
  speciesByGroup,
  setNewGroupName,
  setShowAddGroupDialog,
  toast
) => {
  if (!newGroupName.trim()) {
    toast.error('Skriv inn gruppenavn');
    return;
  }
  
  if (organismGroups.includes(newGroupName.trim())) {
    toast.error('Gruppen finnes allerede');
    return;
  }
  
  setOrganismGroups(prev => [...prev, newGroupName.trim()]);
  setManualGroup(newGroupName.trim());
  speciesByGroup[newGroupName.trim()] = [];
  setNewGroupName('');
  setShowAddGroupDialog(false);
  toast.success(`Gruppe "${newGroupName.trim()}" lagt til`);
};

/**
 * Add a new species to a group
 */
export const addNewSpeciesHelper = (
  newSpeciesName,
  manualGroup,
  speciesByGroup,
  setManualSpecies,
  setNewSpeciesName,
  setShowAddSpeciesDialog,
  toast
) => {
  if (!newSpeciesName.trim()) {
    toast.error('Skriv inn artnavn');
    return;
  }
  
  if (!manualGroup) {
    toast.error('Velg gruppe først');
    return;
  }
  
  if (speciesByGroup[manualGroup]?.includes(newSpeciesName.trim())) {
    toast.error('Arten finnes allerede');
    return;
  }
  
  if (!speciesByGroup[manualGroup]) {
    speciesByGroup[manualGroup] = [];
  }
  speciesByGroup[manualGroup].push(newSpeciesName.trim());
  setManualSpecies(newSpeciesName.trim());
  setNewSpeciesName('');
  setShowAddSpeciesDialog(false);
  toast.success(`Art "${newSpeciesName.trim()}" lagt til under ${manualGroup}`);
};

/**
 * Filter organism groups based on search term
 */
export const getFilteredGroupsHelper = (organismGroups, groupSearchTerm) => {
  if (!groupSearchTerm) return organismGroups;
  return organismGroups.filter(group => 
    group.toLowerCase().includes(groupSearchTerm.toLowerCase())
  );
};

/**
 * Filter species based on search term
 */
export const getFilteredSpeciesHelper = (species, speciesSearchTerm) => {
  if (!speciesSearchTerm) return species;
  return species.filter(s => 
    s.toLowerCase().includes(speciesSearchTerm.toLowerCase())
  );
};
